import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CourseData } from '../../models/course-data';
import { ContentDetailComponent } from '../../components/content-detail/content-detail.component';
import { ContentService } from '../../service/content.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmComponent } from '../../components/dialogs/delete-confirm/delete-confirm.component';
import { PushConfirmComponent } from '../../components/dialogs/push-confirm/push-confirm.component';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ActivateConfirmComponent } from '../../components/dialogs/activate-confirm/activate-confirm.component';


let moment = require('moment');
@Component({
  selector: 'content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.css']
})
export class ContentListComponent implements OnInit {
  displayedColumns: string[] = ['course_name', 'content_title', 'activity_id', 'language', 'locale', 'author', 'updated_at', 'pushed_at', 'uploaded_date', 'content_id'];
  dataSourceCourse: MatTableDataSource<CourseData>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(ContentDetailComponent) current_detail: ContentDetailComponent;
  editMode = false;
  showEdit = false;
  isProd = false;
  contents: any[] = [];
  courses: any[] = [];
  categories: any[] = [];
  categoryNames: string[];
  courseNames: string[];
  currentCourse: CourseData;
  activity_id: string;
  content_key: string;
  course_name: string;
  refreshReportTimer: any;
  remaining: number;
  pageSize: number = 1000;
  currentCoursePage: number = 1;
  currentContentPage: number = 1;
  hasMoreCourses: boolean = true;
  hasMoreContents: boolean = true;
  private copyStatusBackup: { [key: string]: any } = {};
  constructor(iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer, private contentService: ContentService,
    private authService: AuthService, public dialog: MatDialog, private router: Router) {
    iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-edit-24px.svg'));
    iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-delete_forever-24px.svg'));
    iconRegistry.addSvgIcon('play', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-play_circle_outline-24px.svg'));
    iconRegistry.addSvgIcon('add', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-add_circle_outline-24px.svg'));
    iconRegistry.addSvgIcon('save', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-save_alt-24px.svg'));
    iconRegistry.addSvgIcon('cancel', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-cancel-24px.svg'));
    iconRegistry.addSvgIcon('logout', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-exit_to_app-24px.svg'));
    iconRegistry.addSvgIcon('link', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/baseline-link-24px.svg'));
    iconRegistry.addSvgIcon('copy', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/file_copy-24px.svg'));
    iconRegistry.addSvgIcon('more', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/more_vert-24px.svg'));
    iconRegistry.addSvgIcon('info', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/info-24px.svg'));
    iconRegistry.addSvgIcon('visibility', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/visibility-24px.svg'));
    this.dataSourceCourse = new MatTableDataSource(this.contents);
    if (!environment.production) {
      this.showEdit = true;
    } else {
      this.isProd = true;
      const user = sessionStorage.getItem('user');
      if (!user) { this.router.navigate(['login']); }
      const userObj: any = JSON.parse(user);
      userObj.attributes['custom:isTemp'] === 'Y' ? this.showEdit = true : this.showEdit = false;
    }
  }
  saveCategory(current_detail, categories, contentService) {
    return new Promise<void>(function (resolve, reject) {
      if (current_detail.contentForm.value.category_name) {
        const exist = categories.filter(c => c.name == current_detail.contentForm.value.category_name);
        if (exist.length == 0) {
          contentService.createCourseCategory({ name: current_detail.contentForm.value.category_name }).subscribe(e => {
            if (e instanceof HttpResponse) {
              current_detail.contentForm.value.category_id = e.body.category_id;
              return resolve();
            } else if (e instanceof HttpErrorResponse) {
              console.log(e);
              return reject();
            } else {
              console.log(e);

            }
          });
        } else {
          current_detail.contentForm.value.category_id = exist[0].category_id;
          return resolve();
        }
      } else {
        return reject();
      }
    });
  }
  saveCourse(current_detail, courses, contentService) {

    return new Promise<void>((resolve, reject) => {
      if (current_detail.contentForm.value.course_name) {
        const exist = courses.filter(c => c.name === current_detail.contentForm.value.course_name);
        if (exist.length === 0) {
          try {
            contentService.createCourse({
              name: current_detail.contentForm.value.course_name,
              category_id: current_detail.contentForm.value.category_id,
              course_version: current_detail.contentForm.value.course_version
            }).subscribe(e => {
              if (e instanceof HttpResponse) {
                current_detail.contentForm.value.course_id = e.body.course_id;
                return resolve();
              } else if (e instanceof HttpErrorResponse) {
                console.log(e);
                return reject();
              } else {
                console.log(e);

              }
            });
          } catch (ex) {
            console.log(ex);
            return reject();
          }
        } else {
          console.log('sending update course');
          try {
            let course_json = {
              name: current_detail.contentForm.value.course_name,
              category_id: current_detail.contentForm.value.category_id, course_version: current_detail.contentForm.value.version
            };
            contentService.updateCourse(course_json, exist[0].course_id).subscribe(e => {
              if (e instanceof HttpResponse) {
                console.log('e.body:', e.body);
                current_detail.contentForm.value.course_id = exist[0].course_id;
                return resolve();
              } else if (e instanceof HttpErrorResponse) {
                console.log(e);
                return reject();
              } else {
                console.log(e);

              }
            });
          } catch (ex) {
            console.log(ex);
            return reject();
          }
        }
      }
    });
  }
  async saveContent() {

    if (!this.current_detail.contentForm.valid || this.current_detail.hasError) { return; }
    try {
      if (!this.current_detail.contentForm.value.activity_id) { this.current_detail.contentForm.value.activity_id = this.activity_id; }
      if (!this.current_detail.contentForm.value.course_name) { this.current_detail.contentForm.value.course_name = this.course_name; }
      if (!this.current_detail.contentForm.value.content_key) { this.current_detail.contentForm.value.course_name = this.content_key; }
      await this.saveCategory(this.current_detail, this.categories, this.contentService);
      await this.saveCourse(this.current_detail, this.courses, this.contentService);

    } catch (ex) {
      console.log(ex);

    }

    if (this.current_detail.contentForm.value.content_id > 0) {
      this.contentService.updateCourseContent(this.current_detail.contentForm.value).toPromise().then(() => {
        this.reloadAllData();
        this.editMode = false;
      }, r => console.log(r));
    } else {

      this.contentService.createCourseContent(this.current_detail.contentForm.value).toPromise().then(() => {
        this.reloadAllData();
        this.editMode = false;
      }, r => console.log(r));
    }

  }
  reloadContets(page: number = 1) {
    this.contentService.getAllCourseContents(page, this.pageSize).subscribe((event) => {
      if (event instanceof HttpResponse) {
        const pageData = event.body?.data || [];

        // Check if we got less than pageSize items, meaning we're at the end
        if (pageData.length < this.pageSize) {
          this.hasMoreContents = false;
        } else {
          this.hasMoreContents = true;
        }

        // Process and append new content
        if (pageData && Array.isArray(pageData)) {
          for (const content of pageData) {
            if (this.contentService.getCountryCodeByValue(content.country)) {
              content.country = this.contentService.getCountryCodeByValue(content.country).text;
            }
            if (this.contentService.getLanguageCodeByValue(content.language)) {
              content.language = this.contentService.getLanguageCodeByValue(content.language).text;
            }
            this.contents.push(content);
          }
        }

        // Update table data source
        this.dataSourceCourse = new MatTableDataSource(this.contents);
        this.dataSourceCourse.paginator = this.paginator;
        this.dataSourceCourse.sort = this.sort;

        // Load next page if more exists
        if (this.hasMoreContents) {
          this.currentContentPage++;
          this.reloadContets(this.currentContentPage);
        }
      } else if (event instanceof HttpErrorResponse) {
        console.log(event);
      }
    });
  }

  async reloadAllData() {
    // Reset paging and data
    this.currentCoursePage = 1;
    this.currentContentPage = 1;
    this.hasMoreCourses = true;
    this.hasMoreContents = true;
    this.courses = [];
    this.contents = [];
    this.courseNames = [];
    this.categoryNames = [];

    // Load courses with paging
    this.contentService.getAllCourses(this.currentCoursePage, this.pageSize).subscribe((event) => {
      if (event instanceof HttpResponse) {
        const pageData = event.body?.data || [];

        // Check if we got less than pageSize items
        if (pageData.length < this.pageSize) {
          this.hasMoreCourses = false;
        } else {
          this.hasMoreCourses = true;
        }

        // Append courses and update names
        if (pageData && Array.isArray(pageData)) {
          for (const course of pageData) {
            this.courses.push(course);
            this.courseNames.push(course.name);
          }
        }

        // Load next page if more exists
        if (this.hasMoreCourses) {
          this.currentCoursePage++;
          this.loadCoursesPage(this.currentCoursePage);
        }
      } else if (event instanceof HttpErrorResponse) {
        console.log(event);
      }
    });

    // Load categories (no paging needed for categories)
    this.contentService.getAllCourseCategores().subscribe((event) => {
      if (event instanceof HttpResponse) {
        this.categories = event.body.data;
        this.categoryNames = [];
        for (const cat of this.categories) {
          this.categoryNames.push(cat.name);
        }
      } else if (event instanceof HttpErrorResponse) {
        console.log(event);
      }
    });

    // Start loading contents
    this.reloadContets(this.currentContentPage);
  }

  loadCoursesPage(page: number) {
    this.contentService.getAllCourses(page, this.pageSize).subscribe((event) => {
      if (event instanceof HttpResponse) {
        const pageData = event.body?.data || [];

        // Check if we got less than pageSize items
        if (pageData.length < this.pageSize) {
          this.hasMoreCourses = false;
        } else {
          this.hasMoreCourses = true;
        }

        // Append courses and update names
        if (pageData && Array.isArray(pageData)) {
          for (const course of pageData) {
            this.courses.push(course);
            this.courseNames.push(course.name);
          }
        }

        // Load next page if more exists
        if (this.hasMoreCourses) {
          this.currentCoursePage++;
          this.loadCoursesPage(this.currentCoursePage);
        }
      } else if (event instanceof HttpErrorResponse) {
        console.log(event);
      }
    });
  }
  onContentInit(e: any) {
    this.activity_id = e.data.activity_id;
    this.course_name = e.data.name;
    this.content_key = e.data.content_key;
  }
  ngOnInit() {
    this.reloadAllData();
    this.currentCourse = new CourseData('', '', 0, '', '', '', '', '', 0, '', '', 0, 0, '', '', '', '');
  }
  edit(content_id) {
    this.editMode = true;
    this.currentCourse = this.contents.find(c => c.content_id == content_id) as CourseData;
    console.log('selected content', this.currentCourse);

  }
  addNew() {
    this.editMode = true;
    this.currentCourse = new CourseData('', '', 0, '', '', '', '', '', 0, '', '', 0, 0, '', '', '', '');
  }
  openConfirmDelete(content_id: number): void {
    const dialogRef = this.dialog.open(DeleteConfirmComponent, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') { this.delete(content_id); }

    });
  }

  openConfirmPush(content_key: string): void {
    const dialogRef = this.dialog.open(PushConfirmComponent, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') { this.push(content_key); }

    });
  }

  openConfirmActivate(activity_id: string): void {
    const dialogRef = this.dialog.open(ActivateConfirmComponent, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') { this.activate(activity_id); }

    });
  }


  delete(content_id) {
    this.contentService.deleteCourseContent(content_id).toPromise().then(
      () => {

        this.reloadAllData();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  resetTestUserCourseData(content_id) {
    this.contentService.resetUserCourseData(content_id).toPromise().then(
      () => {
        alert("test user course data was reset.");
      },
      (err) => {
        console.log(err);
      }
    );
  }

  activate(activity_id) {

    this.contentService.activateCourseContent(activity_id).toPromise().then(
      () => {

        this.reloadAllData();
      },
      (err) => {
        console.log(err);
      }

    );
  }
  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private setCopyUiStatus(content_key: string, statusText: string): void {
    const row = this.contents.find(c => c.content_key === content_key);
    if (!row) {
      return;
    }

    if (!(content_key in this.copyStatusBackup)) {
      this.copyStatusBackup[content_key] = row.pushed_at;
    }

    row.pushed_at = statusText;
    this.dataSourceCourse.data = [...this.contents];
  }

  private clearCopyUiStatus(content_key: string): void {
    const row = this.contents.find(c => c.content_key === content_key);
    if (!row) {
      return;
    }

    if (content_key in this.copyStatusBackup) {
      row.pushed_at = this.copyStatusBackup[content_key];
      delete this.copyStatusBackup[content_key];
    }

    this.dataSourceCourse.data = [...this.contents];
  }

  private async pollCopyStatus(content_key: string): Promise<any> {
    const maxChecks = 100;

    for (let i = 0; i < maxChecks; i++) {
      const statusEvent = await this.contentService.copyCourseStatus(content_key).toPromise();
      if (statusEvent instanceof HttpResponse) {
        const statusBody = statusEvent.body || {};
        const state = statusBody.state || 'not_started';
        const attempt = statusBody.attempt || 0;
        this.setCopyUiStatus(content_key, `copy:${state} (attempt ${attempt})`);

        if (state === 'completed') {
          return statusBody;
        }

        if (state === 'failed') {
          throw new Error(statusBody.error || 'copy failed');
        }
      }

      await this.delay(3000);
    }

    throw new Error('copy status polling timed out');
  }

  async push(content_key) {
    try {
      this.setCopyUiStatus(content_key, 'copy:starting');

      const event = await this.contentService.copyCourseContentGet(content_key).toPromise();
      if (!(event instanceof HttpResponse) || !event.body) {
        throw new Error('failed to get course copy data');
      }

      const payload = event.body;
      delete payload.category.category_id;
      delete payload.content.content_id;
      delete payload.course.course_id;

      const e2 = await this.contentService.copyCourseContentPost(payload).toPromise();
      if (!(e2 instanceof HttpResponse)) {
        throw new Error('failed to create course copy');
      }

      await this.pollCopyStatus(content_key);

      const e3 = await this.contentService.copyCoursecomplete(content_key).toPromise();
      if (e3 instanceof HttpResponse) {
        this.clearCopyUiStatus(content_key);
        this.reloadAllData();
        alert('Course copy completed successfully.');
      } else {
        throw new Error('failed to finalize copy');
      }
    } catch (err) {
      console.log(err);
      this.clearCopyUiStatus(content_key);
      let errorMessage = 'Course copy failed. Please check logs and retry.';
      if (err) {
        if (err.message) {
          errorMessage = `Course copy failed: ${err.message}`;
        } else if (err.error && err.error.msg) {
          errorMessage = `Course copy failed: ${err.error.msg}`;
        } else if (err.error && err.error.error) {
          errorMessage = `Course copy failed: ${err.error.error}`;
        } else if (err.statusText) {
          errorMessage = `Course copy failed: ${err.statusText}`;
        }
      }
      alert(errorMessage);
    }
  }
  preview(content_id, activity_id, startFromBegining) {
    this.contentService.getCourseContentURL(content_id).toPromise().then(
      (event) => {
        if (event instanceof HttpResponse) {
          var url = new URL(event.body.url);
          if (startFromBegining) {
            //set lastslide to 0 so everytime preview start from first slide
            url.searchParams.set('last_slide', '0');
          }
          console.log(url.toString())
          window.open(url.toString(), '_blank');

          var courseToken = url.searchParams.get("token");
          console.log(courseToken);
          const clearStateUrl = environment.LMS_SERVER_HOST
            + `/v2/user_course_state?activity_id=${activity_id}&token=${courseToken}`;

          // report page
          let x = window.open('', 'lms_preview_reports', 'width=600,height=800,scrollbars=yes,resizable=yes');
          x.document.open();
          x.document.write('<html><body>Initializing...</body></html>');
          x.document.close();
          let cs = this.contentService;
          let startTime = Date.now();
          let refreshReport = function () {
            cs.getLmsProgress(activity_id, startTime).toPromise().then(
              (event) => {
                if (event instanceof HttpResponse) {
                  let lmsProgressJson = event.body;
                  console.log('lmsProgressJson:', JSON.stringify(lmsProgressJson));

                  cs.getPlayerLmsCourseState(activity_id, courseToken).toPromise().then(
                    (event) => {
                      if (event instanceof HttpResponse) {
                        let lmsCourseState = event.body;
                        cs.getLrsReport(activity_id, startTime).toPromise().then(
                          (event) => {
                            if (event instanceof HttpResponse) {
                              let statementsJson = event.body;
                              console.log(statementsJson);

                              cs.getVrmReport(activity_id, startTime).toPromise().then(
                                (event) => {
                                  if (event instanceof HttpResponse) {
                                    let vrmReportJson = event.body;
                                    console.log(vrmReportJson);

                                    // -----------assemble LMS progress info
                                 
                                    var progressHtml = '';
                                    const progresses = lmsProgressJson.progresses || [];
                                    if (progresses.length == 0) {
                                      progressHtml = '<strong style="color:red">No Progress Captured in LMS</strong>';
                                    } else {
                                      for (var i = 0; i < progresses.length; i++) {
                                        var p = progresses[i];
                                        progressHtml += `${p.registration}<ul>
                                      <li>Current Slide Name: ${p.current_slide_name}</li>
                                      <li>Last Slide: ${p.last_slide}</li>
                                      <li>Course Status: ${p.course_status}</li>
                                      <li>is_complete: ${p.is_complete}</li>
                                      <li>passed: ${p.passed}</li>
                                      <li>Activity ID: ${p.activity_id}</li>
                                      <li>stored variables: `;
                                        const stateStr = lmsProgressJson.state?.state || '';
                                        if (stateStr && stateStr.split(":").length > 0) {
                                          progressHtml += `<button href="#" onclick="clearCourseState()">clear state</button><br/>
                                          <ul><li>${stateStr.split(":").join("</li><li>")}</li></ul>`
                                        }
                                        progressHtml += `</li>
                                          </ul>`
                                      }
                                    }
                                    // -----------assemble LRS progress info
                                    var statementsHtml = '';
                                    if (statementsJson.data.length == 0) {
                                      statementsHtml = '<strong style="color:red">No Progress Captured in LRS</strong>';
                                    } else { statementsHtml = cs.getUserLrsProgressStr(statementsJson); }
                                    // -----------assemble derived progress info
                                    var vrmReportHtml = '';
                                    if (!vrmReportJson.data) {
                                      vrmReportHtml = '<strong style="color:red">No VRM report</strong>';
                                    } else {
                                      let vrmReportObj = vrmReportJson.data;
                                      vrmReportHtml += `<ul>
                                      <li>Chapter Progress</li><ul>`;
                                      for (let key in vrmReportObj.chapterCompletion) {
                                        vrmReportHtml += `<li>${key} - ${vrmReportObj.chapterCompletion[key]}</li>`;
                                      }
                                      vrmReportHtml += `</ul>
                                      <li>Total Attempts: ${vrmReportObj.totalAttempts}</li>
                                      <li>Last Attempt Time: ${moment(vrmReportObj.lastAttemptTime).format('LL LTS')}</li>
                                      <li>First Course Complete Time: ${moment(vrmReportObj.firstCompletionTime).format('LL LTS')}</li>
                                      <li>Last Course Complete Time: ${moment(vrmReportObj.lastCompletionTime).format('LL LTS')}</li>
                                      <li>Answers:</li><ul>`;
                                      for (let key in vrmReportObj.vrmQuestionResult) {
                                        vrmReportHtml += `<li>${key} - ${vrmReportObj.vrmQuestionResult[key]}</li>`;
                                      }
                                      vrmReportHtml += `</ul></ul>`;


                                    }

                                    // -----------render data in popup window

                                    x.document.open();
                                    x.document.write(`<html>
            
                                    <script>
                                    var countDownDate = ${new Date().getTime()};
            
                                    // Update the count down every 1 second
                                    var x = setInterval(function() {
                                      var now = new Date().getTime();
                                      var distance = now - countDownDate;
            
                                      // Display the result in the element with id="demo"
                                      document.getElementById("count").innerHTML = Math.round(distance/1000);
                                    }, 1000);
                                    function clearCourseState(){
                                      var data = JSON.stringify({"state":""});

                                      var xhr = new XMLHttpRequest();
                                      xhr.withCredentials = false;

                                      xhr.addEventListener("readystatechange", function() {
                                        if(this.readyState === 4) {
                                          console.log(this.responseText);
                                        }
                                      });

                                      xhr.open("PUT", "${clearStateUrl}");
                                      xhr.setRequestHeader("Content-Type", "application/json");

                                      xhr.send(data);
                                    }
                                    </script>
            
                                    <body style="font-family: monospace !important;height:100%;overflow:scroll">
                                    <i>
                                    How to use progress report tool:
                                    <li>Data refresh every <strong>10 seconds</strong>, wait till data refreshed to verify proper course progress is captured.</li>
                                    <li>At the end of the slide, verify <strong>Current Slide Name</strong> and <strong>Last Slide</strong> is updated correctly.</li>
                                    <li>At the end of the course (or where course is set to complete in storyline), verify <strong>Course Status</strong> is updated to <strong>completed</strong> and <strong>is_complete</strong> is updated to <strong>1</strong></li>
                                    </i>
                                    <br/>
                                    <h2>${activity_id}</h2>
                                    
                                    Data refreshed <span id=count></span> seconds ago, at ${new Date()} <br/><br/>
                                    <h3>LMS progress</h3>
                                    ${progressHtml}
                                    <h3>LRS progress</h3>
                                    ${statementsHtml}
                                    <h3>VRM progress</h3>
                                    ${vrmReportHtml}
                                    </body></html>`);
                                    x.document.close();

                                  } else if (event instanceof HttpErrorResponse) {
                                    console.log(event);
                                  }
                                }
                              );
                            } else if (event instanceof HttpErrorResponse) {
                              console.log(event);
                            }
                          }
                        );
                      }
                    }
                  )
                } else if (event instanceof HttpErrorResponse) {
                  console.log(event);
                }
              }
            );
          };

          if (this.refreshReportTimer) { clearInterval(this.refreshReportTimer); }
          refreshReport();
          this.refreshReportTimer = setInterval(refreshReport, 10000);

        } else if (event instanceof HttpErrorResponse) {
          console.log(event);
        }
      }
    );
  }
  previewMeta(content_id, activity_id, filePath) {
    this.contentService.getCourseContentURL(content_id).toPromise().then(
      (event) => {
        if (event instanceof HttpResponse) {
          const url = event.body.url;

          var metaUrl = url.substr(0, url.indexOf("story.html")) + filePath;
          window.open(metaUrl, '_blank');

        } else if (event instanceof HttpErrorResponse) {
          console.log(event);
        }
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSourceCourse.filter = filterValue.trim().toLowerCase();
    if (this.dataSourceCourse.paginator) {
      this.dataSourceCourse.paginator.firstPage();
    }
  }

}

